<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <Breadscrumbs
      :links="[
        { name: 'Support Warranty Policy', to: { path: '/support-warranty-policy' } },
        { name: 'Create', to: { path: '/support-warranty-policy/create' } },
      ]"
    ></Breadscrumbs>

    <!-- page-actions -->
    <div class="page-actions">
      <h2>新增Support Warranty Policy</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- block -->
    <SupportWarrantyPolicyCreateEdit></SupportWarrantyPolicyCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SupportWarrantyPolicyCreateEdit from '@/views/H-3__SupportWarrantyPolicy/c/SupportWarrantyPolicyCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    SupportWarrantyPolicyCreateEdit,
  },
  created() {
    this.setPolicy({});
  },
  computed: {
    ...mapState('supportWarrantyPolicy', [
      'policy',
    ]),
  },
  methods: {
    ...mapActions('supportWarrantyPolicy', {
      savePolicy: 'save',
      setPolicy: 'setPolicy',
    }),
    cancelHandler() {
      this.$router.go(-1);
    },
    async saveHandler() {
      this.savePolicy(this.policy).then(() => {
        this.$router.push({ name: 'SupportWarrantyPolicy' });
      });
    },
  },
};
</script>

<style></style>
